import { Suspense, ComponentType, PropsWithChildren } from 'react'
import { LazyErrorBoundary } from 'components/LazyErrorBoundary/LazyErrorBoundary'

const LazyWrapper =
  <T,>(Component: ComponentType<React.PropsWithChildren<T>>) =>
  (props: T) => {
    const fallback = <div />

    return (
      <LazyErrorBoundary>
        <Suspense fallback={fallback}>
          <Component {...(props as PropsWithChildren<T>)} />
        </Suspense>
      </LazyErrorBoundary>
    )
  }

export { LazyWrapper }
